export default __webpack_public_path__ + "zhinengyunbdcf1a.png";